import { API_BASE_URL } from '../settings';
import axios from 'axios';

export const getQuestionsByTopicId = (topicId) => {
  return axios
    .get(API_BASE_URL + 'topics/' + topicId + '/questions')
    .then(res => res.data)
    .then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/services/question.services.js